import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import LandingPage from "@/components/LandingPage";
import AdminLogin from "@/components/AdminLogin";
import AdminDashboard from "@/components/AdminDashboard";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import MessyRoomsToolPage from "@/components/MessyRoomsToolPage";
import BuildingBridgeToolPage from "@/components/BuildingBridgeToolPage";
import BuildingBridgePreview from "@/components/BuildingBridgePreview";
import CoursesPage from "@/components/CoursesPage";
import CourseViewer from "@/components/CourseViewer";
import ResourcesPage from "@/components/ResourcesPage";
import JournalPage from "@/components/JournalPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App grain-overlay">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/tools/messy-rooms" element={<MessyRoomsToolPage />} />
          <Route path="/tools/building-the-bridge" element={<BuildingBridgeToolPage />} />
          <Route path="/tools/building-the-bridge/preview" element={<BuildingBridgePreview />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/courses/view/:courseId" element={<CourseViewer />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/journal" element={<JournalPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
